import { PageResponse } from '@core/entities/pagination'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  taskTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/tasks/templates'
import {
  ITaskTemplateVersion,
  TaskTemplateVersion,
} from '@core/entities/task/TaskTemplateVersion'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const dataTransformer = ({
  content,
  ...response
}: PageResponse<ITaskTemplateVersion>) => {
  return {
    ...response,
    content: content.map((template) => TaskTemplateVersion.new(template)),
  }
}

export const useGetTaskTemplateVersions = (
  params: RequestTypes['getTaskTemplateVersions'],
  options?: UseQueryOptions<
    PageResponse<ITaskTemplateVersion>,
    RequestErrorType,
    PageResponse<TaskTemplateVersion>
  >,
) => {
  return useQuery<
    PageResponse<ITaskTemplateVersion>,
    RequestErrorType,
    PageResponse<TaskTemplateVersion>
  >({
    select: dataTransformer,
    ...taskTemplateKeys.getTaskTemplateVersions(params),
    ...options,
  })
}
